import { Controller, useFormContext } from "react-hook-form";

import { FormSection } from "@/components/ui/form-section";
import { TriStateField } from "@/components/cadastro/tri-state-field";
import { CONSENT_FIELDS, type CadastroDraft } from "@/lib/cadastro-draft";
import { CadastroLabels } from "@/lib/labels";

export function ConsentsSection() {
	const { control } = useFormContext<CadastroDraft>();

	return (
		<FormSection title={CadastroLabels.sectionTitle.consents}>
			<div className="grid grid-cols-1 gap-x-6 gap-y-1 sm:grid-cols-2">
				{CONSENT_FIELDS.map((field) => (
					<Controller
						key={field}
						control={control}
						name={field}
						render={({ field: controlled }) => (
							<TriStateField
								label={CadastroLabels.consent[field]}
								value={controlled.value}
								onChange={controlled.onChange}
								slot={`consent-${field}`}
							/>
						)}
					/>
				))}
			</div>
		</FormSection>
	);
}
